export default __webpack_public_path__ + "c6569a4859e03cd78302a37f3d7f0f5b.png";